import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "nav-items-container" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item nav-item-navbar-menu" }
const _hoisted_5 = { class: "navbar-menu" }


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

  const menuItems = [
    { name: 'Home', path: '/' },
    { name: 'Play', path: '/play' },
    // { name: 'Get songs', path: '/songs' },
    // { name: 'Level editor', path: '/editor' }
  ]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "navbar-logo"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
            return _createElementVNode("li", {
              key: item.name
            }, [
              _createVNode(_component_router_link, {
                to: item.path,
                class: _normalizeClass(["menu-item", { active: _ctx.$route.path === item.path }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ])
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})